module.exports = "<app-confirmation-code [mode]=\"mode\"></app-confirmation-code>\n"